// extracted by mini-css-extract-plugin
export var logo = "_ki-2";
export var logoWrapper = "_ki-1";
export var strip = "_ki-0";